import { LayoutIconProps } from '../LayoutArea';

export const LAYOUT_ICON_PROPS: LayoutIconProps = { width: '30px', height: '30px' };
